<script lang="ts">
  import type { WalletCard } from "../wallet/types";
  import { cn } from "./lib/utils";

  export let card: WalletCard;
  export let size: "sm" | "md" | "lg" = "md";
  export let tilt = false;
  let className = "";
  export { className as class };

  let imageFailed = false;

  function issuerInitials(c: WalletCard): string {
    const ascii = (c.issuer || c.name || "").replace(/[^A-Za-z0-9一-龥]/g, "").slice(0, 2);
    return ascii || c.shortName.slice(0, 2);
  }

  $: dims = size === "lg" ? "h-24 w-36" : size === "md" ? "h-20 w-28" : "h-12 w-16";
  $: textSize = size === "lg" ? "text-2xl" : size === "md" ? "text-xl" : "text-sm";
  $: isCustom = card.sourceLevel === "user_self_reported" || card.coverageStatus === "user_self_reported";
  $: isPending = card.sourceLevel === "official_pending" || card.coverageStatus === "auto_discovered";
  $: useImage = !!card.imageUrl && !imageFailed;
</script>

<div class={cn("relative shrink-0", dims, className)}>
  {#if useImage}
    <img
      src={card.imageUrl}
      alt={card.imageAlt || `${card.shortName || card.name} 卡面`}
      class={cn(
        "h-full w-full rounded-lg object-cover ring-1 ring-foreground/10 shadow-lg transition-transform",
        tilt && "duration-300"
      )}
      style={tilt ? "transform: perspective(600px) rotateY(-8deg) rotateX(2deg);" : ""}
      loading="lazy"
      on:error={() => (imageFailed = true)}
    />
  {:else}
    <div
      class={cn(
        "flex h-full w-full items-center justify-center rounded-lg ring-1 ring-foreground/10 shadow-lg font-semibold tracking-wider text-primary",
        textSize
      )}
      style="background: linear-gradient(135deg, hsl(var(--primary) / 0.30), hsl(var(--primary) / 0.04)); {tilt
        ? 'transform: perspective(600px) rotateY(-8deg) rotateX(2deg);'
        : ''}"
    >
      {issuerInitials(card)}
    </div>
  {/if}
  {#if isCustom}
    <span
      class="absolute -bottom-1 -right-1 rounded-full bg-warn px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-warn-foreground shadow-md"
      title="用户自录的卡 · 权益规则待官方核实"
    >
      自录
    </span>
  {:else if isPending}
    <span
      class="absolute -bottom-1 -right-1 rounded-full bg-warn/85 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-warn-foreground shadow-md"
      title="扩充收录 · 年费/权益需以发卡行渠道核对"
    >
      待核
    </span>
  {/if}
</div>
